import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { TermsAndConditionsComponent } from './terms-conditions.component';

const routes: Routes = [
  { path: '', component: TermsAndConditionsComponent, data: { title: 'Terms & Conditions' } },
  { path: 'view', component: TermsAndConditionsComponent, data: { readonly: true } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TermsConditionsRoutingModule {}

@NgModule({
  imports: [
    TermsConditionsRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [TermsAndConditionsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TermsConditionsModule {}
